import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import LinkIcon from "@material-ui/icons/Link";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import FeaturedLink from "../../Models/FeaturedLink";
import ListItemProps from "../../Models/ListItemProps";

interface FeaturedLinkListItemProps extends ListItemProps<FeaturedLink> {
    icon?: any;
}

const FeaturedLinkListItem = (props: FeaturedLinkListItemProps) => {
    const {item, onClick, icon} = props;

    return (
        <>
            <ListItem
                button
                onClick={() => { if (onClick) onClick(item)}}
            >
                <ListItemIcon>
                    {icon || <LinkIcon/>}
                </ListItemIcon>
                <ListItemText primary={item?.title || ""} />
            </ListItem>
            <Divider variant={'middle'} component={'li'} />
        </>
    );
};

export default FeaturedLinkListItem;